import { Actions } from '../Auth/utils/interfaces';

const orcidResultType = ['success', 'error'] as const;
export type OrcidResultType = typeof orcidResultType[number];

const orcidMethod = ['push', 'pull'] as const;
export type OrcidMethod = typeof orcidMethod[number];

export interface OrcidResult {
  type: OrcidResultType;
  method?: OrcidMethod;
  message?: string;
}

export interface Props {
  onClose: () => void;
  result: OrcidResult;
}

export const orcidRequest = async (orcidId: string, method: OrcidMethod, actions: Actions): Promise<OrcidResult> => {
  const token: string | undefined = await actions.getAuthTokenOrRefresh(true);
  if (!token) {
    return {type: 'error', method, message: 'Missing, expired or invalid sso token'};
  }
  if (!orcidId) {
    return {type: 'error', method, message: 'Missing Orcid ID'};
  }
  const params: { [key: string]: { method: string; url: string } } = {
    'push': {
      method: 'POST',
      url: `https://${window.location.hostname}/mms3-orcid/orcid/core/connect/${orcidId}/works?access_token=${token}`,
    },
    'pull': {
      method: 'GET',
      url: `https://${window.location.hostname}/mms3-orcid/orcid/core/collect/${orcidId}/works?access_token=${token}`,
    },
  };
  if (!params[method]) {
    return {type: 'error', method, message: 'Invalid Method:' + method};
  }
  const result: Response = await fetch(params[method].url, {method: params[method].method});
  if (!result.ok) {
    return {type: 'error', method, message: result.statusText};
  }
  return {type: 'success', method};
};
